import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgaModule } from '../../theme/nga.module';

import { CustomFormsModule } from 'ng2-validation'

import { LoginComponent } from './components/login.component';
import { ForgotPasswordComponent } from './components/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password.component';
import { ChangePasswordComponent } from './components/change-password.component';
import { routing } from './user.routing';
import { SharedModule } from '../../shared/shared.module';

import { Oauth2TokenService } from './services/oauth2-token.service';
import { LocalStorageService } from './services/local-storage.service';
import { UserWebService } from './services/user.web.service';
import { LoginService } from './services/login.service';
import { OAuthService } from './services/oauth.service';
import { UserStorageService } from './services/user-storage.service';
import { IntroComponent } from '../intro/components/intro.component';
import { RecoveryService } from './services/recovery.service';
import { HandleLoggedUserGuard } from './services/handle-logged-user-guard.service';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgaModule,
    routing,
    SharedModule,
    CustomFormsModule,
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    IntroComponent,
    ChangePasswordComponent
  ],
  providers: [
    Oauth2TokenService,
    LocalStorageService,
    UserWebService,
    LoginService,
    OAuthService,
    UserStorageService,
    RecoveryService,
    HandleLoggedUserGuard
  ]
})
export class UserModule {}
